import React from 'react'
import MainIcon from '../../../../img/svg/main'
import { TableData, TableDataContent, TableDataIconWrap, TableDataNumber, TableDataPrice, TableDataPriceWrap, TableDataTimer, TableDataTimerText, TableDataWaiter, TableDataWaiterWrap } from '../SVGTables/index.styled'
import Currency from '../../../Elements/currency'
import { RestTableWaiterComing, RestTableWaiterComingText, RestTableWaiterText, RestTableWaiterWrapper } from '../../../Restaurant/areas/tables/table/index.styled'
import { useTranslation } from 'react-i18next'
import { getRestTableData } from './helper'
import { useSelector } from 'react-redux'
import { selectIsTimerLimitExceeded, selectTimeSinceLastOrder } from '../../../../redux/selector/timerCounter'

const RestTableComponent = React.memo(({
	data, i, handleObjClick = () => {
	}, isQRCode,
	isSettingsArea, isSettingsForm,
	totalPrice, uuid, processedBy, tableWaiterCall, isReadyFood, disabled,
	timerOffsets,
}) => {
	const { t } = useTranslation()
	const timer = useSelector(selectTimeSinceLastOrder(data.lastOrderDate))
	const isTimerLimit = useSelector(selectIsTimerLimitExceeded(data.lastOrderDate))
	const layoutData = data?.formType.toLowerCase() + ' '
	const isExistPaidBeforeOrders = data.payBeforeOrders?.length > 0
	const paidBeforeOrdersMoreThanOne = data.payBeforeOrders?.length > 1
	const paidBeforeOrdersAndOrders = isExistPaidBeforeOrders && (data.orders?.length > 0 || data.splits?.length > 0)
	const isVertical = data.width < data.height
	const restTableData = getRestTableData({ isSettingsForm, isSettingsArea, isReadyFood, isQRCode, isExistPaidBeforeOrders, paidBeforeOrdersMoreThanOne, paidBeforeOrdersAndOrders, totalPrice, processedBy, t })
	const icons = restTableData?.icons
	const className = restTableData?.className
	const price = restTableData?.price
	const text = restTableData?.text
	const waiterName = restTableData?.waiterName
	const layout = (isVertical ? 'vertical ' : '') + (className ? `${className} ` : '') + (disabled ? 'disabled ' : '') + (tableWaiterCall ? 'waiterCall ' : '')
	const tableNumber = data?.number
	const testIdParam = tableNumber ? tableNumber : i
	const layoutForDataTimer = layoutData + layout + (isTimerLimit ? ' timer-limit' : '')
	const tableTimerConfigs = useSelector(store => store.restaurantSettings.tableTimerConfigs)
	const isShowTableTimer = tableTimerConfigs ? !tableTimerConfigs?.timerDisabled : false
	const showTimer = isShowTableTimer && data.lastOrderDate

	return (
		<>
			{showTimer &&
				<TableDataTimer className={layoutForDataTimer} top={timerOffsets?.top} data-testid="timer-limit">
					<MainIcon icon="clock" />
					<TableDataTimerText>{timer}</TableDataTimerText>
				</TableDataTimer>}

			<TableData className={layoutData + layout} id={uuid}>
				<TableDataContent className={layout}>
					<TableDataNumber className={layout + ' number '}>{tableNumber}</TableDataNumber>
					{tableWaiterCall ?
						<RestTableWaiterWrapper>
							<RestTableWaiterText>{t('restaurant.waiterCall')}</RestTableWaiterText>
							<RestTableWaiterComing>
								<RestTableWaiterComingText>{t('restaurant.waiterComingShort')}</RestTableWaiterComingText>
							</RestTableWaiterComing>
						</RestTableWaiterWrapper>
						: <>
							{(price || text) &&
								<TableDataPriceWrap className={layout}>
									{price && <TableDataPrice className={layout + ' total-price'}><Currency>{price}</Currency></TableDataPrice>}
									{text && <TableDataPrice className={layout}>{text}</TableDataPrice>}
								</TableDataPriceWrap>}
							{icons.length > 0 &&
								<TableDataIconWrap onClick={() => handleObjClick(data?.id, 'table')}
																	 onGotPointerCapture={() => handleObjClick(data?.id, 'table')}
																	 className={layout}
																	 data-testid={`table-icon-${testIdParam}`}>
									{icons.map((icon, index) => <MainIcon key={index} icon={icon} />)}
								</TableDataIconWrap>}
						</>}
				</TableDataContent>

				{waiterName && !tableWaiterCall &&
					<TableDataWaiterWrap className={layoutData + layout}>
						<TableDataWaiter data-testid={`table-waiter-${testIdParam}`} className={layout}>
							{waiterName}
						</TableDataWaiter>
					</TableDataWaiterWrap>}
			</TableData>
		</>
	)
})
RestTableComponent.displayName = 'RestTableComponent'
export default RestTableComponent
